import _get from 'lodash/get';
import { Sector } from 'graphql-common';
import { Value, Values } from '@lib/interfaces/form';
import SectorFieldNames from '@lib/enums/fieldNames/sectorFieldNames';
import removeTypenameDeep from '@lib/utils/removeTypenameDeep';
import { defaultValues } from './getSectorFormFields';

export default function getDefaultValuesFromQueryData(
  data?: Sector | null,
  assigneeIds?: { id: string }[],
  sitesIds?: { id: string }[],
): Values {
  return {
    ...defaultValues,
    [SectorFieldNames.Id]: _get(data, 'id', null),
    [SectorFieldNames.Name]: _get(data, 'name', ''),
    [SectorFieldNames.Code]: _get(data, 'code', ''),
    [SectorFieldNames.Description]: _get(data, 'description', ''),
    [SectorFieldNames.Color]: data?.color ? { value: data.color } : null,
    [SectorFieldNames.Sites]:
      sitesIds && sitesIds?.length > 0
        ? sitesIds.map(({ id }) => ({ value: id }))
        : null,
    [SectorFieldNames.UserId]: data?.user
      ? ({
          label: data.user.firstName,
          value: data.user.id,
          data: data.user,
        } as Value)
      : null,
    [SectorFieldNames.UserMemberships]:
      assigneeIds && assigneeIds?.length > 0
        ? assigneeIds.map(({ id }) => ({ value: id }))
        : null,
    [SectorFieldNames.LocationGeojson]: data?.locationBoundary?.geojson
      ? removeTypenameDeep(data.locationBoundary.geojson)
      : {
          type: 'FeatureCollection',
          features: [],
        },
  };
}
